import React from 'react';
import PropTypes from 'prop-types';
import styles from './PercentageChart.css';

/**
  Simple PercentageChart component
  Horizontal line with marker
  indicating a set of percentage values
  with corresponding labels.
*/
const PercentageChart = ({ data }) => {
    data.forEach(([, v]) => {
        if (v < 0)
            throw new TypeError('percent values must be greater than zero');
    });

    const sum = data.reduce((acc, [, v]) => acc + v, 0);

    // scale each value as a percentage of their sum
    const m = 100 / sum;
    const normalizedData = data.map(([l, v, c]) => [l, v * m, c]);

    return (
        <React.Fragment>
            <div className="bar">
                {normalizedData.map(([l, v, c]) => {
                    const markerStyle = {
                        width: `${v}%`,
                        background: c.toString()
                    };

                    return (
                        <div
                            key={`marker-${l}`}
                            style={markerStyle}
                            className="marker"
                        />
                    );
                })}
            </div>

            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

PercentageChart.propTypes = {
    /**
      Array of data, values are two index
      array first index "label"
      second index is "value"
    */
    data: PropTypes.instanceOf(Array).isRequired
};

export default PercentageChart;
